import { FieldMetaProps } from 'formik';
import { DefaultTheme } from 'styled-components';
import { Option } from './PropertyPalSelect';

const colourStyles = (
  meta: FieldMetaProps<any> | null,
  asyncSelect: boolean,
  theme: DefaultTheme,
  fixedHeight?: string,
  isMulti?: boolean,
  noBorder?: boolean,
  border?: boolean,
  fieldValue?: Option,
  selectBox?: any,
  hasIcon?: boolean,
) => {
  const determineHeight = () => {
    if (isMulti) return 'auto';
    if (noBorder) return parseInt(selectBox.control.height, 10) - 4;
    return selectBox.control.height;
  };

  const determineMinHeight = () => {
    return 'inherit';
  };

  const determineBoxShadow = () => {
    if (noBorder) return null;
    if (border) return `inset 0 0 0 ${border};`;

    let inset = '';
    if (meta && meta.touched && meta.error != null) {
      inset = `2px ${theme?.primary}`;
    } else {
      inset = `1px ${selectBox.option?.defaultBoxShadowColor || theme?.altoGrey}`;
    }
    return `inset 0 0 0 ${inset}`;
  };

  const valueContainerHeight = () => {
    if (noBorder) return parseInt(selectBox.valueContainer.height, 10) - 4;
    if (isMulti) return 'auto';
    return selectBox.valueContainer.height;
  };

  const valueContainerMinHeight = () => {
    if (isMulti) return selectBox.valueContainer.height;
    return null;
  };

  const valueContainerPadding = (styles: any) => {
    if (isMulti) return '8px';
    if (noBorder) return 0;
    return styles.padding;
  };

  const valueContainerPaddingLeft = (styles: any) => {
    let padding = parseInt(valueContainerPadding(styles), 10);
    if (hasIcon) padding += 30;
    return `${padding}px`;
  };

  const backgroundOptionBackgroundColour = (state: any) => {
    if (state.isDisabled) return selectBox.option.defaultBackgroundColor;
    if (state.isSelected) return selectBox.option.selectedBackgroundColor;
    if (state.isFocused) return selectBox.option.hoverBackgroundColor;
    return selectBox.option.defaultBackgroundColor;
  };

  const getInputOpacity = () => {
    if (fieldValue && asyncSelect) return { opacity: '1 !important' };
    return null;
  };

  return {
    control: (styles: any) => ({
      ...styles,
      ...selectBox.control,
      height: determineHeight(),
      minHeight: determineMinHeight(),
      boxShadow: determineBoxShadow(),
      border: 'none',
      fontFamily: 'Open Sans',
      '& input': {
        font: 'Open Sans',
      },
    }),
    placeholder: (styles: any) => ({ ...styles, ...selectBox.placeholder }),
    group: (styles: any) => ({ ...styles, ...selectBox.group }),
    groupHeading: (styles: any) => ({ ...styles, ...selectBox.groupHeading }),
    multiValue: (styles: any) => ({ ...styles, ...selectBox.multiValue }),
    multiValueLabel: (styles: any) => ({ ...styles, ...selectBox.multiValueLabel }),
    multiValueRemove: (styles: any) => ({ ...styles, ...selectBox.multiValueRemove }),
    input: (styles: any) => ({
      ...styles,
      fontFamily: 'Open Sans',
      '& input': {
        fontFamily: 'Open Sans',
        background: 'red',
        ...getInputOpacity(),
      },
    }),
    menu: (styles: any) => ({
      ...styles,
      ...selectBox.menu,
      boxShadow: asyncSelect ? 'none' : selectBox.menu?.boxShadow || styles.boxShadow,
    }),
    menuList: (styles: any) => ({
      ...styles,
      ...selectBox.menuList,
      maxHeight: fixedHeight || styles.maxHeight,
    }),
    valueContainer: (styles: any) => ({
      ...styles,
      ...selectBox.valueContainer,
      height: valueContainerHeight(),
      minHeight: valueContainerMinHeight(),
      padding: valueContainerPadding(styles),
      paddingLeft: valueContainerPaddingLeft(styles),
    }),
    dropdownIndicator: (styles: any) => ({
      ...styles,
      ...selectBox.dropdownIndicator,
      padding: noBorder ? 0 : styles.padding,
    }),
    clearIndicator: (styles: any) => ({
      ...styles,
      ...selectBox.clearIndicator,
    }),
    option: (styles: any, state: any) => ({
      ...styles,
      color: state.isSelected ? selectBox.option.selectedColor : selectBox.option.defaultColour,
      backgroundColor: backgroundOptionBackgroundColour(state),
      padding: selectBox.option.padding,
      lineHeight: selectBox.option.lineHeight,
      cursor: 'pointer',
      transition: 'background-color 300ms linear',
      fontWeight: selectBox.option?.fontWeight || styles.fontWeight,
      fontSize: selectBox.option?.fontSize || styles.fontSize,
      ':active': {
        color: selectBox.option.selectedColor,
        backgroundColor: selectBox.option.selectedBackgroundColor,
      },
    }),
  };
};
export default colourStyles;
